export const idDict = {
  'Account recovery requires verified contact information':
    'Pemulihan akun memerlukan informasi kontak terverifikasi',
  'An account with the given email already exists.':
    'Akun dengan email tersebut sudah terdaftar.',
  'Attempt limit exceeded, please try after some time.':
    'Batas percobaan terlampaui, mohon coba lagi setelah beberapa waktu.',
  'Back to Sign In': 'Kembali ke Masuk',
  'Cannot reset password for the user as there is no registered/verified email or phone_number':
    'Tidak dapat mengatur ulang kata sandi karena tidak ada email terdaftar / terverifikasi atau nomor telepon',
  Change: 'Ubah',
  'Change Password': 'Ubah kata sandi',
  Code: 'Kode',
  Confirm: 'Konfirmasi',
  'Confirm a Code': 'Konfirmasi kode',
  'Confirm Password': 'Konfirmasi kata sandi',
  'Confirmation Code': 'Kode Konfirmasi',
  'Create a new account': 'Buat akun baru',
  'Create account': 'Buat akun',
  'Create Account': 'Buat Akun',
  'Creating Account': 'Membuat Akun',
  Confirming: 'Mengkonfirmasi',
  Email: 'Email',
  'Enter your code': 'Masukkan kode anda',
  'Enter your email': 'Masukkan email anda',
  'Enter your password': 'Masukkan kata sandi anda',
  'Enter your phone number': 'Masukkan nomor telepon anda',
  'Enter your username': 'Masukkan nama akun anda',
  'Forgot Password': 'Lupa kata sandi',
  'Forgot your password?': 'Lupa kata sandi? ',
  'Have an account? ': 'Sudah punya akun? ',
  Hello: 'Halo',
  'Incorrect username or password.': 'Nama akun atau kata sandi salah.',
  'Invalid phone number format': 'Nomor telepon tidak sesuai dengan format.',
  'Invalid verification code provided, please try again.':
    'Kode verifikasi tidak sesuai, mohon coba lagi.',
  'It may take a minute to arrive.': 'Mungkin perlu beberapa waktu untuk tiba.',
  'Lost your code? ': 'Kode anda hilang?',
  Name: 'Nama',
  'Network error': 'Galat jaringan',
  'New password': 'Kata sandi baru',
  'No account? ': 'Tidak ada akun?',
  or: 'atau',
  Password: 'Kata sandi',
  'Password did not conform with policy: Password not long enough':
    'Kata sandi tidak sesuai dengan aturan: Kata sandi kurang panjang',
  'Phone Number': 'Nomor telepon',
  'Resend a Code': 'Renvoyer un code',
  'Resend Code': 'Kirim ulang kodenya',
  'Reset password': 'Ubah kata sandi anda',
  'Reset your password': 'Ubah kata sandi anda',
  Send: 'Kirim',
  'Send Code': 'Kirim Kode',
  'Send code': 'Kirim kode',
  Sending: 'Mengirim',
  'Sign in': 'Masuk',
  'Sign In': 'Masuk',
  'Sign in to your account': 'Masuk akun anda',
  'Sign In with Amazon': 'Masuk dengan Amazon',
  'Sign In with AWS': 'Masuk dengan AWS',
  'Sign In with Facebook': 'Masuk dengan Facebook',
  'Sign In with Google': 'Masuk dengan Google',
  'Sign Up with Amazon': 'Daftar dengan Amazon',
  'Sign Up with AWS': 'Daftar dengan AWS',
  'Sign Up with Facebook': 'Daftar dengan Facebook',
  'Sign Up with Google': 'Daftar dengan Google',
  'Signing in': 'Memasuki',
  Skip: 'Lewati',
  SMS: 'SMS',
  Submit: 'Ajukan',
  Submitting: 'Mengajukan',
  'User is disabled.': 'Akun dinonaktifkan.',
  'User already exists': 'Akun sudah terdaftar',
  'User does not exist.': 'Akun tidak terdaftar.',
  Username: 'Nama akun',
  'Username cannot be empty': 'Nama akun tidak boleh kosong',
  'Username/client id combination not found.':
    'Nama akun atau id tidak ditemukan.',
  Verify: 'Verifikasi',
  'Verify Contact': 'Verifikasi Kontak',
  'We Emailed You': 'Kami mengirimkanmu email',
  'Your code is on the way. To log in, enter the code we emailed to':
    'Kode anda dalam pengiriman. Untuk masuk, masukkan kode yang kami emailkan ke',
  'Your code is on the way. To log in, enter the code we texted to':
    'Kode anda dalam pengiriman. Untuk masuk, masukkan kode yang kami tuliskan ke',
  'Your passwords must match': 'Kata sandi harus sama',
};
